import React, { useState } from "react";
import Responsive from "react-responsive";
import { useSelector } from "react-redux";
import AttendanceSupervisor, { TIME_LIST_VIEWS } from "pages/AttendanceSupervisor";
import Layout from "components/Layout";
import Modal from "components/Modal";
import MobileAttendanceView from "components/AttendanceSupervisor/Mobile/MobileAttendanceView";
import { AttendanceProvider } from "hooks/attendance/AttendanceContext";

/** Alineado con `Layout` (988px): mismo rango que menú hamburguesa / sidebar estrecho. */
const ATTENDANCE_MOBILE_MAX_WIDTH_PX = 987;

const AttendanceMobile = (props) => (
	<Responsive {...props} maxWidth={ATTENDANCE_MOBILE_MAX_WIDTH_PX} />
);
const AttendanceDesktop = (props) => (
	<Responsive {...props} minWidth={ATTENDANCE_MOBILE_MAX_WIDTH_PX + 1} />
);

const AttendanceSupervisorResponsive = (props) => {
	const user = useSelector((state) => state.authReducer?.user);
	const [timeListView, setTimeListView] = useState(TIME_LIST_VIEWS.list);

	return (
		<>
			<AttendanceDesktop>
				<AttendanceSupervisor {...props} />
			</AttendanceDesktop>
			<AttendanceMobile>
				<AttendanceProvider
					timeListView={timeListView}
					timeRegistrationBalanceCalculation={
						user?.time_registration_balance_calculation
					}
				>
					<Layout
						className="page-times attendance-supervisor mobile"
						context="times"
					>
						<MobileAttendanceView
							timeListView={timeListView}
							onChangeTimeListView={setTimeListView}
						/>
					</Layout>
					<Modal />
				</AttendanceProvider>
			</AttendanceMobile>
		</>
	);
};

export default AttendanceSupervisorResponsive;
